import * as React from 'react';
export default function useLock(duration = 250) {
    const lockRef = React.useRef(null);
    const timeoutRef = React.useRef(null);
    React.useEffect(() => () => {
        window.clearTimeout(timeoutRef.current);
    }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) {
            lockRef.current = locked;
        }
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(() => {
            lockRef.current = null;
        }, duration);
    }
    return [() => lockRef.current, doLock];
}
